export default {
    builders: {
        searchable: {
            create: 'Create ',
        },
        yearMonthPicker: {
            defaultSelect: 'Select a month',
        },

        localeDropdown: {
            languages: {
                en: 'English',
                cn: 'Chinese',
                de: 'German',
                es: 'Spanish',
                fi: 'Filipino',
                fr: 'French',
                it: 'Italian',
                jp: 'Japanese',
                ko: 'Korean',
                nl: 'Dutch',
                pt: 'Portuguese',
                ro: 'Romanian',
                ru: 'Russian',
                vi: 'Vietnamese',
            },
        },
    },

    miscellaneous: {
        verifyModule: {
            title: 'Verify your school e-mail',
            description: `It's a quick process and will give you access to
                            exclusive features like unique job postings, skill
                            tests and career resources.`,

            verificationPending: 'Verification pending',
            weHaveSentAnEmail: ` We have sent an e-mail to
                                <strong>{studentEmail}</strong> for
                                you to verify yourself. Be sure to
                                check your spam folder, as many schools are
                                quite strict on incoming emails.`,
            verifyMe: 'Verify me',
            resendVerifyEmail: 'Resend verification email',
            cancelVerification: 'Cancel verification',

            emailSent: 'Email sent',
            emailSentMessage:
                'Email was successfully sent. If you do not receive it, contact us at support@highered.global.',

            resendErrorTitle: 'Error during resending email',
            resendErrorMessage:
                'Was not able to resend verification email. Please contact us at support@highered.global.',

            verificationCancelledTitle: 'Verification cancelled',
            verificationCancelledMessage: 'Verification was successfully cancelled.',

            verificationIgnoredTitle: 'Verification ignored',
            verificationIgnoredMessage: 'Verification was successfully ignored.',

            verificationUnignoredTitle: 'Verification unignored',
            verificationUnignoredMessage: 'Verification was successfully unignored.',

            cancelErrorTitle: 'Error during cancellation',
            cancelErrorMessage:
                'Was not able to cancel verification. Please contact us at support@highered.global.',

            statusChangeErrorTitle: 'Error during verification change',
            statusChangeErrorMessage:
                'Was not able to perform verification change. Please contact us at support@highered.global.',
        },

        verifyModuleDialog: {
            title: 'Verify your school e-mail',
            university: 'Academic Institution',
            studentEmail: 'Your academic e-mail address',
            studentEmailPlaceholder: 'Academic email',
            message: 'Message',

            verify: 'Verify',
            sendRequest: 'Send request',

            verificationInProcess: 'Verification in process',
            emailHasBeenSentTo:
                'An email has been sent to <strong>{email}</strong>. Follow the instructions there to verify your connection to <strong>{schoolName}</strong>',
            verificationRequestSentNonAcademic:
                'Career services at <strong>{schoolName}</strong> will need to verify your connection. You will be notified by email when that happens.',
            ifNoEmailRecieved: 'If you have not received the verification mail please contact us.',
            contactHelp: 'Contact us for help',

            doNotHaveAcademicEmail: 'I do not have an academic email address',
            doubleCheckEmail:
                'Please double check that this email address is correct and that you have access to it.',
            haveAcademicEmail: 'I have an academic email address',
            noAcademicEmailInfo:
                'If you do not use an academic email address your request will need to be manually approved by career services. You must therefore supply a short message to identify yourself.',
            alreadyVerifiedInfo: 'You are already verified at this school.',
        },

        addNameDialog: {
            title: 'Please finish your profile ',
            content:
                'To access referrals, you need to update your profile with your first and last name.',
        },

        verifiedSchoolDropdown: {
            placeholder: 'Select school',
            none: 'Show all',
        },

        schoolVerificationAlert: {
            title: 'Incomplete Verification.',
            defaultText:
                'Complete it to unlock the Global Badge, gain recognition as a reputable candidate, and access exclusive events, career content, and jobs.',
            jobText:
                'Verify your education to unlock exclusive jobs, and earn the prestigious talent badge to gain recognition as a reputable candidate. In addition, access exclusive events and career content.',
            resourcesText:
                'Verify your education to access additional resources exclusive to talent at your school.',
            calendarText:
                'Verify your education to access the appointment functionality exclusive to talent at your school.',
            verifyButton: 'Verify Now',
            closeButtonTooltip: 'Hide this message until the end of the day',
        },

        efmdBadge: {
            tooltips: {
                unverified:
                    "Verify your education to unlock the Highered badge and boost your profile's visibility, making you a standout candidate in the eyes of employers.",
                verified:
                    'You have successfully verified your education. The Highered Badge will put your profile in the spotlight and positions you as a high-performing candidate in the eyes of employers.',
            },
        },
    },

    navigation: {
        navigation: {
            myPage: 'My page',
            myProfile: 'My Profile',
            jobs: 'Jobs',
            companies: 'Companies',
            employers: 'Employers',
            masterclasses: 'Masterclasses',
            resources: 'Resources',
            assessments: 'Assessments',
            careerPlanning: 'Career Planning',
            calendar: 'Calendar',
            coursera: 'Courses',
            countryGuides: 'Country Guides',
            goToHaigui: 'Jobs in China',
            signIn: 'Log in / Sign up',
            vfairs: 'Virtual Events',
            events: 'Events',
            schoolEvents: 'Events',
            newFeature: 'New Feature!',
            conference: 'Conference',
            chat: 'Chat',
            documents: 'My Page',
            cvReview: 'CV Review',
            blog: 'Blog',
            tools: 'Tools',
            internalResources: 'Resources',
            account: 'Account',

            vfairMode: {
                backToAllEvents: 'Back to All Events',
                updateMyProfile: 'Update My Profile',
                eventLobby: 'Event Lobby',
            },

            info: {
                masterclasses: 'Videos for your career development',
                documents: 'Documents, Resources, Calendar & more',
                assessments: 'Test your skills and behavior',
                coursera: 'Upskill and get certified',
                cvReview: 'Get your CV reviewed by experts',
                blog: 'News update and articles to help you',
                resources: 'Templates, Highered 5 & more',
                calendar: 'Book an appointment',
            },
        },

        profileNavigation: {
            editProfile: 'View / Edit Profile',
            yourProfileScore: 'Your profile is <strong>{score}% complete</strong>',
            settings: 'Settings',
            favorites: 'Favorites',
            myCVs: 'My documents',
            faqs: 'FAQs',
            account: 'My account',
            cookies: 'Cookies',
            signOut: 'Sign out',
        },

        sidebar: {
            myPage: 'My page',
            myProfile: 'My profile',
            findJobs: 'Jobs',
            findCompanies: 'Employers',
            masterclasses: 'Masterclasses',
            assessments: 'Assessments',
            careerPlanning: 'Career Planning',
            coursera: 'Upskill',
            countryGuides: 'Country Guides',
            goToHaigui: 'Jobs in China',
            virtualFairs: 'Events',
            resources: 'Resources',
            blog: 'Blog',
            chat: 'Chat',

            signIn: 'Log in / Sign up',
            logOut: 'Log out',

            vfairMode: {
                backToAllEvents: 'Back to All Events',
                updateMyProfile: 'Update My Profile',
                eventLobby: 'Event Lobby',
            },
        },
        backToCalendar: 'Back to calendar',
        allBooths: 'All booths',
        home: 'Home',
    },

    select: {
        select: 'Select',
    },

    smart: {
        companyModule: {
            followJob: 'Add to favorites',
            followCompany: 'Follow company',
            unFollowJob: 'Remove from favorites',
            unFollowCompany: 'Unfollow company',

            favoritedTitle: 'Saved to favorites',
            favoritedMessage:
                'This position has been saved to your favorites. Find your favorite positions on My Page.',
            unfavoritedTitle: 'Removed from favorites',
            unfavoritedMessage: 'This position has been removed from your favorites.',
            favoriteErrorTitle: 'Something went wrong',
            favoriteErrorMessage: 'Was not able to favorite this position',
            showAllCompanies: 'Show all booths',
            showOnlyCompaniesLiveOnChat: 'Show only booths live on chat',
        },
        profileModule: {
            profileCompletion: 'Profile completion',
            profileCompletionEncouragement:
                'Fast-track your career and unlock the chance to connect with recruiters by completing the last {percentageLeft}% of your profile',
            gotoProfilePage: 'Complete your profile',
            profileCompleted: 'Profile completed',
            profileCompletedWhatsNext:
                'Did you know that most employers use online assessments in their recruiting processes? Practice now and get insights on your strengths and weaknesses.',
            gotoTestsPage: 'Go to assessment center',
            profileCompletedHasAssessments:
                'Did you know that the game has changed and most employers are now using online assessments to find the perfect candidate? Get ahead of the game by practicing now and discovering your hidden strengths and weaknesses, be the boss of your own career journey.',

            authIndication: {
                title: 'Find your dream job',
                description:
                    'Do you want access to positions that are unique to your school, and tests that will supercharge your job search? Easily create a user with Google, LinkedIn or Facebook today.',
                action: "Let's go",
            },

            toProfileHint: 'To my profile',
            toProfileUncompletedHint:
                'Your profile is not 100% complete. Please proceed by completing in order to maximize your employability.',

            profileActions: {
                addFirstName: 'Add first name',
                addLastName: 'Add last name',
                addNationality: 'Add nationality',
                addPhoneNumber: 'Add your phone number',
                addLanguage: 'Add a language',
                addEducation: 'Add an education',
                addEmail: 'Add your email',
                addGender: 'Add your gender',
            },
        },

        featuredCompanies: {
            label: 'Featured Companies',
        },

        featuredPositions: {
            label: 'Featured Positions',
        },

        featuredResource: {
            header: 'Join the Virtual Conference',
            cta: 'Watch now!',
            wechatSignupHeader: 'Follow the Highered WeChat account to get updates',
            wechatSignupCta: 'Scan code to now!',
        },
    },
};
